<template>
  <div
    class="people-tag"
    :class="{'active': active}"
    :data-qa="dataQa"
    @click.prevent.stop="select"
    @mouseover="$emit('mouseover')">
    <UserIcon
      :data-qa="`people-tag-${value.contactId}-userIcon`"
      :name="value.name"
      size="32"/>
    <div
      class="people-tag__name"
      :data-qa="`${dataQa}-name`">
      {{ value.name }}
    </div>
  </div>
</template>
<script>
import UserIcon from 'components/header/UserIcon.vue'

export default {
  name: 'tagUserItem',
  methods: {
    select() {
      this.$emit('select', this.value)
    }
  },
  props: {
    value: {
      type: Object
    },
    active: {
      type: Boolean
    },
    dataQa: {
      type: String,
      default: 'tag-user-item'
    }
  },
  components: {
    UserIcon,
  }
}
</script>
<style scoped lang="scss">
.people-tag {
  display: flex;
  flex-wrap: nowrap;
  padding: 6px 6px 6px 20px;
  transition: 0.25s;
  cursor: pointer;
  &.active,
  &:hover,
  &:focus {
    background: var(--color-main-green);
  }
  &__name {
    margin: auto 0;
    padding-left: 9px;
    font-size: 14px;
    line-height: 18px;
    color: var(--black-color);
  }
}
</style>
